import M1Overview from "@/pages/m1/overview";
import M1ShiftReport from "@/pages/m1/shift-report";
import M1Campaign from "@/pages/m1/schedule";

export const routeM1Overview = "/m1/overview";
export const routeM1ShiftReport = "/m1/shift-report";
export const routeM1Schedule = "/m1/schedule";
export const routeM1StackerProduction = "/stacker-production";

export const m1Routes = [
	{
		path: routeM1Overview,
		element: <M1Overview />,
		permission: "ui.navbar.m1.mill.overview",
	},
	{
		path: routeM1ShiftReport,
		element: <M1ShiftReport />,
		permission: "ui.navbar.m1.shift.report",
	},
	{
		path: `${routeM1ShiftReport}/:shiftId`,
		element: <M1ShiftReport />,
		permission: "ui.navbar.m1.shift.report",
	},
	{
		path: routeM1Schedule,
		element: <M1Campaign />,
		permission: "ui.navbar.m1.mill.schedule",
	},
	{
		path: `${routeM1Schedule}/:campaignId`,
		element: <M1Campaign />,
		permission: "ui.navbar.m1.mill.schedule",
	},
	{
		path: routeM1StackerProduction,
		element: <M1ShiftReport />,
		permission: "ui.navbar.m1.stacker.production",
	},
	{
		path: `${routeM1StackerProduction}/:shiftId`,
		element: <M1ShiftReport />,
		permission: "ui.navbar.m1.stacker.production",
	},
];
